<template>
	<el-dialog class="online-dialog" :close-on-click-modal="false" title="网站诊断记录" :visible.sync="dialogVisible" @close="close" @open="open" width="660px">
		<div class="check-history">
			<div class="check-history-table">
				<el-table :data="tableData" stripe style="width: 100%">
					<el-table-column prop="createdTime" label="诊断时间" width="180"></el-table-column>
					<el-table-column prop="score" label="综合得分" width="180"></el-table-column>
					<el-table-column label="与上次相比">
						<template slot-scope="scope">
							<span v-if="scope.row.status > 0" style="color:#00ff00">
								<i class="el-icon-top"></i>
							</span>
							<span v-if="scope.row.status < 0" style="color:#dd2c00">
								<i class="el-icon-bottom"></i>
							</span>
							<span v-if="scope.row.status == 0" style="color:#333">
								<i class="el-icon-minus"></i>
							</span>
						</template>
					</el-table-column>
				</el-table>
			</div>

			<el-pagination style="text-align: center" :hide-on-single-page="true" :total="total" :page-size="pageSize" @current-change="currentChange" layout="prev, pager, next"></el-pagination>
		</div>
	</el-dialog>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
	name: 'CheckHistory',
	props: ['show', 'pid'],
	data() {
		return {
			total: 0,
			pageNum: 1,
			pageSize: 6,
			tableData: []
		}
	},
	computed: {
		dialogVisible: {
			get: function () {
				return this.show
			},
			set: function (val) {

			}
		}
	},
	created() {

	},
	methods: {
		...mapActions('templateConfig', ['publishProj', 'getProgress']),
		...mapActions('template', ['getResult']),
		open() {
			this.init()
		},
		close() {
			this.pageNum = 1
			this.tableData = []
			this.$emit('updateHistory')
		},
		async init() {
			let res = await this.getResult({
				projId: this.pid,
				pageNo: this.pageNum,
				pageSize: this.pageSize
			})
			let data = res.data.data
			this.total = data.total
			this.tableData = this.buildTableData(data.list)
		},
		buildTableData(list) {
			if (!list.length) {
				return []
			}
			let result = []
			list.forEach((item, index) => {
				let json = {}
				json.createdTime = item.createdTime
				item.checkResult = item.checkResult ? item.checkResult : '{}'
				json.score = JSON.parse(item.checkResult).score
				if (index == list.length - 1) {
					json.status = 0
				} else {
					list[index + 1].checkResult = list[index + 1].checkResult ? list[index + 1].checkResult : '{}'
					let next = JSON.parse(list[index + 1].checkResult)
					json.status = json.score - next.score
				}
				result.push(json)
			})
			return result
		},
		currentChange(pageNum) {
			this.pageNum = pageNum
			this.init()
		}
	}
}
</script>

<style scoped lang="scss">
.check-history {
	width: 100%;
	.check-history-table {
		height: 340px;
	}
}
</style>
